<template>
  <div v-if= "mode === 'portfolio-builder'">
    <b-tooltip
      v-bind:label="`${ screen.is_inclusionary ? 'Green flag (positive) for' : 'Red flag (negative) for' } ${ screen.is_binary ? 'all' : 'the worst' } companies associated with this metric`"
      multilined
      position="is-bottom"
      type="is-light"
      class="switch-widget"
    >
      <b-switch
        v-model="switchState"
        size="is-medium"
      >
      </b-switch>
    </b-tooltip>
  </div>
  <div v-else >
    <b-tooltip
      v-bind:label="`Add to Values Set`"
      multilined
      position="is-bottom"
      type="is-light"
      class="switch-widget"
    >
      <b-switch
        v-model="switchState"
        size="is-medium"
      >
      </b-switch>
    </b-tooltip>
  </div>
</template>
<script>
  import Vue from 'vue';


  export default {
    data() {
      return {
      }
    },
    props: {
      screen: Object,
    },
    computed: {
      switchState: {
        get: function() {
          return this.screen.userPercentile === 0 ? false : true;
        },
        set: function(value) {
          let percentile;
          if (this.screen.is_binary) {
            percentile = value ? 100 : 0;
          }
          else {
            percentile = value ? 10 : 0;
          }
          this.$emit('change', percentile);
        }
      },
      mode: function() {
        return window.location.href.includes('portfolio-builder') ? 'portfolio-builder' : 'values-selector';
      },
    },
    methods: {},
    created: function() {
      
    },
    beforeUpdate: function() {
    },
    mounted: function() {

    },
  }
</script>

<style lang="scss">
</style>
